import { login, logout, getInfo } from '@/api/login'
import Cookies from 'js-cookie'
import axios from 'axios'

const user = {
  state: {
    name: '',
    avatar: '',
    isLogin: false,
    roles: [],
    shopId: ''
  },

  mutations: {
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_LOGIN: (state, status) => {
      state.isLogin = status
      localStorage.setItem('isLogin', status)
    },
    SET_ROLES: (state, roles) => {
      state.roles = Array.isArray(roles) ? roles : [roles]
    },
    SET_SHOP: (state, shopId) => {
      state.shopId = shopId
    },
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          // 检查响应中的 data 字段
          if (response.data && response.data.success === true) {
            // 设置登录状态
            commit('SET_LOGIN', true)
            resolve(response.data)
          } else {
            reject(new Error(response.data ? response.data.errMsg : '登录失败'))
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          console.log('获取用户信息响应:', response)
          if (response.data.success === true && response.data) {
            const data = response.data.data
            // 设置用户类型/角色
            if (data.userType !== undefined) {
              commit('SET_ROLES', data.userType)
              localStorage.setItem('userType',data.userType)
            }
            // 设置用户名
            if (data.username) {
              commit('SET_NAME', data.username)
              localStorage.setItem('name',data.username)
            }
             // 设置店铺id  adminPlatformInfo
             if (data.merchantInfo && data.merchantInfo.shopId) {
              commit('SET_SHOP', data.merchantInfo.shopId)
              localStorage.setItem('shopId',data.merchantInfo.shopId)
            }
            if (data.adminPlatformInfo && data.adminPlatformInfo.shopId) {
              commit('SET_SHOP', data.adminPlatformInfo.shopId)
              localStorage.setItem('shopId',data.adminPlatformInfo.shopId)
            }
            // 设置头像
           
            resolve(data)
          } else {
            reject(new Error(response.errMsg || '获取用户信息失败'))
          }
        }).catch(error => {
          console.log('获取用户信息错误:', error)
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_NAME', '')
        commit('SET_AVATAR', '')
        commit('SET_LOGIN', false)
        commit('SET_ROLES', [])
        localStorage.removeItem('isLogin')
        localStorage.removeItem('userInfo')
        localStorage.removeItem('shopId')
        localStorage.removeItem('name')
        localStorage.removeItem('userType')
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js